﻿import { useState } from 'react';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { Alert, Stack, TextField, Paper, styled } from '@mui/material';
import './beneStyles.css';

const HowManyBene = (props) => {
  const [beneCount, setBeneCount] = useState(4);

  const saveBeneCount = () => {
    let d = JSON.parse(window.sessionStorage.getItem('currentBene'));
    d.beneficiaryCount = beneCount;
    window.sessionStorage.setItem('currentBene', JSON.stringify(d));
    props.nextHandler();
  };

  return (
    <>
      <Stack spacing={2}>
        <Alert severity="info">
          Approximately how many total primary and contingent beneficiaries do you expect? This will
          help us determine the number of forms to send.
        </Alert>
        <BeneFormItem>
          <span className="formLabel">Estimated Beneficiaries:</span>
          <TextField
            type="number"
            className="fullwidth"
            value={beneCount}
            onChange={(e) => {
              setBeneCount(e.target.value);
            }}
          />
        </BeneFormItem>
      </Stack>
      <WizardButtons {...props} nextHandler={saveBeneCount} />
    </>
  );
};
const decideColor = (theme) => {
  let color = '';
  if (theme.palette.mode === 'dark') {
    color = '#1A2027';
  } else {
    color = '#FFF';
  }
};
const BeneFormItem = styled(Paper)(({ theme }) => ({
  backgroundColor: decideColor(theme),
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '.25em',
  color: theme.palette.text.secondary,
}));

export { HowManyBene };
